import Vue from 'vue'
import Vuex from 'vuex'
import { V } from './V'

import axios from "axios";
/*const instance = axios.create({
  baseURL: V.SERVER
});*/

axios.interceptors.request.use(config => {
    let session = JSON.parse(localStorage.getItem(V.STORE_KEYS.SESSION))
    if (session) {
        config.headers.common[V.SESSION] = session[V.SESSION]
    }
    return config
}, error => {
    console.log(error)
})

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        axios: axios,
        showLoader: false,
        banks: [],
        economicActivities: [],
        leadStatus: [],
        mxStates: [],
        generalInfo: {},
        activeAccountsPerBank: {},
        tracingStatus: [],
        userTraceStatus: [],
        accountTraceStatus: [],
        sellers: [],
        customerService: [],
        userHistoryEvents: [],
        userInactiveCatalog: []
    },
    mutations: {
        setBanks(state, value) { state.banks = value },
        setEconomicActivities(state, value) { state.economicActivities = value },
        setSellers(state, value) { state.sellers = value },
        setCustomerService(state, value) { state.customerService = value },
        setLeadStatus(state, value) { state.leadStatus = value },
        setUserTraceStatus(state, value) { state.userTraceStatus = value },
        setAccountTraceStatus(state, value) { state.accountTraceStatus = value },
        setMxStates(state, value) { state.mxStates = value },
        setGeneralInfo(state, value) { state.generalInfo = value },
        setTracingStatus(state, value) { state.tracingStatus = value },
        setShowLoader(state, value) { state.showLoader = value },
        setUserHistoryEvents(state, value) { state.userHistoryEvents = value },
        setUserActionsCatalog(state, value) { state.userActionsCatalog = value },
        setUserInactiveCatalog(state, value) { state.userInactiveCatalog = value },
    },
    getters: {
        getBanks(state) { return state.banks },
        getEconomicActivities(state) { return state.economicActivities },
        getMxStates(state) { return state.mxStates },
        getGeneralInfo(state) { return  state.generalInfo },
        getTracingStatus(state) { return state.tracingStatus },
        getUserTraceStatus(state) { return state.userTraceStatus },
        getAccountTraceStatus(state) { return state.accountTraceStatus },
        getShowLoader(state) { return state.showLoader },
        getUserHistoryEvents(state) { return state.userHistoryEvents },
        getUserActionsCatalog(state) { return state.userActionsCatalog },
        getUserInactiveCatalog(state) { return state.userInactiveCatalog }
    },
    actions: {
        showLoader({ commit }) {
            commit('setShowLoader', true)
        },
        hideLoader({ commit }) {
            commit('setShowLoader', false)
        },
        async downloadBanks({ commit }) {
            let url = V.SERVER + V.OPS.SELECT + V.TABLES.BANKS
            axios.post(url).then(response => {
                if (response.data[V.API_SUCCESS]) {
                    commit('setBanks', response.data[V.API_ROWS])
                } else { console.log("error d_banks") }
            })
        },
        async downloadEconomicActivities({ commit }) {
            let url = V.SERVER + V.OPS.SELECT + V.TABLES.ECONOMIC_ACTIVITIES
            axios.post(url).then(response => {
                if (response.data[V.API_SUCCESS]) {
                    commit('setEconomicActivities', response.data[V.API_ROWS])
                } else { console.log("error d_economicActivities") }
            })
        },
        async downloadSellers({ commit }) {
            let url = V.SERVER + V.SELLER_OPS.GET_CONSULTANTS + "?role=seller&enabled=1"
            axios.get(url).then(response => {
                if (response.data[V.API_SUCCESS]) {
                    commit('setSellers', response.data[V.API_ROWS])
                } else { console.log("error d_sellers") }
            })
        },
        async downloadCustomerService({ commit }) {
            let url = V.SERVER + V.SELLER_OPS.GET_CONSULTANTS + "?role=service&enabled=1"
            axios.get(url).then(response => {
                if (response.data[V.API_SUCCESS]) {
                    commit('setCustomerService', response.data[V.API_ROWS])
                } else { console.log("error d_CustomerService") }
            })
        },
        async downloadLeadStatus({ commit }) {
            let url = V.SERVER + V.OPS.SELECT + V.TABLES.LEADS_STATUS
            axios.post(url).then(response => {
                if (response.data[V.API_SUCCESS]) {
                    commit('setLeadStatus', response.data[V.API_ROWS])
                } else { console.log("error d_LeadStatus") }
            })
        },
        async downloadUserTraceStatus({ commit }) {
            let url = V.SERVER + V.OPS.SELECT + V.TABLES.USER_TRACE_STATUS
            axios.post(url).then(response => {
                if (response.data[V.API_SUCCESS]) {
                    commit('setUserTraceStatus', response.data[V.API_ROWS])
                } else { console.log("error d_UserTraceStatus") }
            })
        },
        async downloadAccountTraceStatus({ commit }) {
            let url = V.SERVER + V.OPS.SELECT + V.TABLES.ACCOUNTS_TRACE_STATUS
            axios.post(url).then(response => {
                if (response.data[V.API_SUCCESS]) {
                    commit('setAccountTraceStatus', response.data[V.API_ROWS])
                } else { console.log("error d_AccountTraceStatus") }
            })
        },
        async downloadMxStates({ commit }) {
            let url = V.SERVER + V.OPS.GET_MX_STATES
            axios.get(url).then(response => {
                if (response.data[V.API_SUCCESS]) {
                    commit('setMxStates', response.data[V.API_ROWS])
                } else { console.log("error d_MxStates") }
            })
        },
        async downloadTracingStatus({ commit }) {
            let url = V.SERVER + V.OPS.SELECT + V.TABLES.LEADS_STATUS
            axios.post(url).then(response => {
                if (response.data[V.API_SUCCESS]) {
                    commit('setTracingStatus', response.data[V.API_ROWS])
                } else { console.log("error d_TracingStatus") }
            })
        },
        async downloadGeneralInformation({ commit }) {
            let url = V.SERVER + V.SELLER_OPS.GET_GENERAL_INFO
            return axios.get(url).then(response => {
                let gInfo = response.data
                if (gInfo[V.API_SUCCESS]) {
                    commit('setGeneralInfo', gInfo[V.API_ROW])
                } else { console.log("error d_GeneralInfo") }
            })
        },
        async downloadUserHistoryEvents({ commit }) {
            let url = V.SERVER + V.SELLER_OPS.GET_USER_HISTORY_EVENTS
            axios.get(url).then(response => {
                if (response.data[V.API_SUCCESS]) {
                    commit('setUserHistoryEvents', response.data[V.API_ROWS])
                } else { console.log("error d_userHistoryEvents") }
            })
        },
        async downloadUserActionsCatalog({ commit }) {
            let url = V.SERVER + V.CONSULTANT_OPS.GET_USER_ACTIONS_CATALOG
            axios.get(url).then(response => {
                if (response.data[V.API_SUCCESS]) {
                    commit('setUserActionsCatalog', response.data[V.API_ROWS])
                } else { console.log("error d_userActionsCatalog") }
            })
        },
        async downloadUserInactiveCatalog({ commit }) {
            let url = V.SERVER + V.CONSULTANT_OPS.GET_INACTIVE_CATALOG
            axios.get(url).then(response => {
                if (response.data[V.API_SUCCESS]) {
                    commit('setUserInactiveCatalog', response.data[V.API_ROWS])
                } else { console.log("error d_userInactiveCatalog") }
            })
        }
        
    }
})

export default store